// extracted by mini-css-extract-plugin
module.exports = {"orderDetails":"OrderDetails_orderDetails__1pBXY","row":"OrderDetails_row__1rzXJ","divider":"OrderDetails_divider__2V6Bz"};